<template>
  <div class="userRefund">
    <div class="header">申请退款</div>
    <div class="userRefund_con">
      客服电话:15840721070客服工作时间:<br>
      上午10:00-12:00下午13:00-19:00<br>
      <!-- 关注客服公众号，在对话框内输入您在阅读过程中想了解的内容热情耐心的客服<br>小助理将火速赶到，竭诚为您解答。<br> -->
      <!-- <div style="margin-left: 40px;"><img  @dragstart.prevent  width="160px" src="../../assets/wxkefu.jpg" alt=""></div> -->
    </div>
    <div class="header">退款协议</div>
    <div class="serviceWrap" v-for="(item, index) in serviceList " :key="index">
      <div class="serviceWrap_title">{{ item.title }}</div>
      <div class="serviceWrap_con" v-if='item.id == 1'>
        本说明是您与太原巴卡巴科技经营者之间关于充值后产生退款相关服务所订立的协议。太原巴卡巴科技的经营者是指法律认可的经营太原巴卡巴科技的责任主体。
        "用户"是指使用太原巴卡巴科技旗下产品相关服务的使用人，在本协议中更多地称为"您"。
      </div>
      <div class="serviceWrap_con" v-if='item.id == 2'>
        1.您理解并同意，太原巴卡巴科技有权免费或要求付费提供本服务；本服务收取的充值金额是太原巴卡巴科技为了向最终用户收取互联网增值服务使用费，而提供的一种通用的收费渠道或计费方式。该充值金额不能用于本服务以外的任何产品或服务。<br>

        2.完成充值行为后进行消费行为的，对于已消费的金额，太原巴卡巴科技不予退还。用户就用户账户中尚未消费的充值金额申请退款的，可联系客服并配合提供相关证明材料，太原巴卡巴科技会对该用户的退款事宜进行审核。太原巴卡巴科技如审核通过的，将会根据用户充值时选取的支付手段将相应充值金额原路返还给用户，并扣除对应手续费。<br>

        3.您理解并同意，太原巴卡巴科技有权自行决定并修订相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本协议的有效组成部分。太原巴卡巴科技可根据实际需要对收费服务的收费标准、方式进行修改和变更，也可对部分免费服务开始收费。前述修改、变更或开始收费前，太原巴卡巴科技将在相应服务页面进行通知或公告。如您不同意前述标准、规则及其修订，您有权停止使用本服务。您继续使用本服务即视为您同意相关内容。<br>
      </div>
      <div class="serviceWrap_con" v-if='item.id ==3'>
        1.如果您对本协议或本服务有意见或建议，可与太原巴卡巴科技旗下产品网站客服专区联系，我们会给予您必要的帮助。
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, watch } from "vue";
let serviceList = ref([
  { title: '一、【协议的范围】', id: 1 }, { title: '二、【收费、充值、退款服务】', id: 2 }, { title: '三、【其他】', id: 3 }
])

</script>

<style lang="scss" scoped>
.userRefund {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
    margin-bottom: 20px;

  }


  &_con {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-bottom: 40px;
  }

  .serviceWrap {
    &_title {
      font-size: 22px;
      
      color: #333333;
      line-height: 30px;
      margin: 30px 0 20px;
    }

    &_con {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      color: #333333;
      line-height: 36px;
    }

    &_con1 {
      font-size: 16px;
    }
  }

}
</style>